import React from 'react'
import NavigationSection from "../../../core/model2/navigation/navigation-section"
import {NavigationButtonPosition} from "../../../core/model2/navigation/@const"
import sessionInitChats from "../../../core/gd-session/chat/init-chats"
import {ReorderItemProps} from "../../../core/gd-ui/sortable-list-4/@types"
import Navigation_ButtonHint from "../hint/hint";

type Props = {
    className?          : string,
    section             : NavigationSection,
    onClickCallback?    : callback
    inMorePopover       : boolean
} & ReorderItemProps

// const debug = "Navigation_ButtonChats"
const debug = false

export default class Navigation_ButtonChats extends React.Component<Props,any> {

    public refHint                  : React.RefObject<Navigation_ButtonHint> = React.createRef<Navigation_ButtonHint>()

    constructor(props:Props) {
        super(props);

        this.state = {
            newMessagesCount: gd.session.counters.getChatNewMessagesCount(),
        };
    }

    componentDidMount() {
        gd.session.counters.on('change:chatNewMessages',this.onCounterChanged);
    }

    componentWillUnmount() {
        gd.session.counters.off('change:chatNewMessages',this.onCounterChanged);
    }

    onCounterChanged = () => {
        this.setState({
            newMessagesCount: gd.session.counters.getChatNewMessagesCount()
        })
    }

    showContextMenu = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
    }

    onClick = async () => {
        if (this.props.onClickCallback) this.props.onClickCallback()

        this.refHint?.current?.hideHint()

        if (!gd.session.chatsLoaded) await sessionInitChats()

        // check if defaultAppUrl chat is still available
        let defaultAppUrl
        if (this.props.section.defaultAppUrl) {
            const chatId = _.last(this.props.section.defaultAppUrl.split('/'))
            if (chatId && gd.session.chats.get(chatId)) {
                defaultAppUrl = this.props.section.defaultAppUrl
            }
            // clear defaultAppUrl if chat is not found
            this.props.section.defaultAppUrl = defaultAppUrl
        }

        await gd.layout.navigation.openSectionV2(this.props.section)

        debug && console.log(debug, 'onClick', this.props.section, gd.session.chats)

        gd.goTo(defaultAppUrl || gd.session.chats.latestUpdatedChat?.url || 'chat')
    }

    render() {

        const isSelected = gd.layout.navigation.state.currentSection === this.props.section

        const homeClasses = Classes('ui5-navigation-btn', this.props.className, {
            'i5-nav-chat'          : !isSelected,
            'i5-nav-chat-solid'    : isSelected,
            selected                    : isSelected && !this.props.inMorePopover,
            'is-dragged'                : this.props.dndIsDragged,
            'is-hover'                  : !this.props.dndIsDragInProgress && this.props.isMouseEntered,
            'is-preview'                : this.props.dndPreview
        });

        return (
            <div className={homeClasses} onClick={this.onClick} onContextMenu={this.showContextMenu}>

                {this.state.newMessagesCount > 0 && <div className="btn-counter">{this.state.newMessagesCount}</div>}

                {this.props.section.position!==NavigationButtonPosition.MORE &&
                    <Navigation_ButtonHint section={this.props.section} ref={this.refHint} />
                }
            </div>
        )
    }
}
